/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var form_resets = document.querySelectorAll('.js-form-reset');
  form_resets.forEach((form_reset) => {
    form_reset.addEventListener('click', (e) => {
      e.preventDefault();

      var form = form_reset.closest('form');

      if(!form) {
        console.log('No form');
        return;
      }

      var fields = form.querySelectorAll('.field');

      if(!fields) {
        console.log('No fields');
        return;
      }

      fields.forEach((field) => {
        field.classList.remove('field-error');

        var error_message = field.querySelector('.input-error');
        if(error_message) {
          error_message.remove();
        }

        var inputs = field.querySelectorAll('input, select, textarea');
        inputs.forEach((input) => {
          switch(input.nodeName) {
            case 'INPUT':
              switch(input.getAttribute('type')) {
                case 'hidden':
                  break;
                case 'checkbox':
                  input.checked = false;
                  break;
                case 'text':
                case 'number':
                default:
                  input.value = '';
                  break;
              }
              break;
            case 'SELECT':
              input.value = input.querySelector('option:first-child').getAttribute('value');
              break;
            case 'TEXTAREA':
              input.value = '';
              break;
          }
        });

        const resetEvent = new Event('form-reset');
        form.dispatchEvent(resetEvent);
      });
    });
  });
}());

function tec_search_form_field_show(field, update_required = true) {
  field.classList.remove('hidden');

  // if(update_required) {
  //   tec_search_form_field_update_required(field, true);
  // }
}

function tec_search_form_field_hide(field, update_required = true) {
  field.classList.add('hidden');

  // if(update_required) {
  //   tec_search_form_field_update_required(field, false);
  // }
}

function tec_search_form_field_update_required(field, required) {
  var field_inputs = field.querySelectorAll('input, select');

  if(field_inputs) {
    field_inputs.forEach((field_input) => {
      if(!field_input.classList.contains('not-required')) {
        field_input.required = required;
      }
    });
  }
}